<template>
  <div>
    <div class="container-fluid white-bg no-shadow">
      <div class="container align-middle">
        <div class="row">
          <div class="col-12">
            <div class="land-t-delimeter" style="margin-bottom: 60px;"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p>Родителей часто тревожит вопрос, будет ли развитие ребёнка гармоничным, если он уделяет электронным гаджетам больше внимания, чем обычным игрушкам. Но волноваться не стоит: таким образом малыш познаёт окружающий мир, важной частью которого сегодня являются цифровые технологии. Чтобы помочь ему в этом непростом деле, подключайтесь к занятиям на образовательной платформе HomeTeacher от языкового центра&nbsp; Полиглотики.</p>

            <h2 class="redh2">О платформе HomeTeacher</h2>

            <p>Платформа HomeTeacher осуществляет дистанционное обучение дошкольников испанскому языку. На ней собраны видеоуроки и методические материалы, разработанные с учётом новейших достижений педагогики, психологии и лингвистики.</p>

            <p>Для того чтобы начать занятия на платформе, достаточно указать в специальной форме на сайте возраст ребёнка и язык, который вы хотите изучать. При необходимости можно пройти бесплатный тест для определения уровня знаний. Выбрав нужный курс и внеся оплату, вы получите доступ к обучающим видео и методическим материалам. Доступ сохраняется&nbsp; на 12-18 месяцев, поэтому вы в любое время сможете повторить полюбившийся урок.</p>

            <h3 class="greenh2">Преимущества удалённого обучения</h3>

            <p>Онлайн-курсы испанского языка для дошкольников имеют ряд преимуществ:</p>

            <ol>
              <li><span>Демократичные цены. Цена одного занятия в Полиглотиках начинается от 90 р, а целого курса &mdash; от 290 р. Приобрести курс на платформе HomeTeacher гораздо выгоднее, чем заниматься офлайн, тем более, что первый урок можно пройти совершенно бесплатно. Таких условий вам не предложит ни один репетитор!</span></li>
              <li><span>Профессиональное преподавание. Онлайн-обучение дошкольников испанскому языку в Полиглотиках осуществляют только опытные сертифицированные преподаватели, многие из которых являются носителями языка. Мы ведём строгий отбор: лишь 1 из 50 претендентов становится нашим сотрудником.</span></li>
              <li><span>Уникальная методика. Наши онлайн курсы испанского языка для детей 4, 5 и 6 лет призваны сформировать у малышей устойчивый интерес к обучению. Мы отказались от утомительной зубрёжки и превратили изучение иностранного в увлекательную игру. С самого первого урока ребёнок погружается в языковую среду и естественным образом усваивает новые слова.&nbsp; Занятия по такой методике эффективны также для детей 7 и 8 лет.</span></li>
            </ol>

            <h2 class="redh2">Результаты обучения на платформе HomeTeacher</h2>

            <p>Онлайн школа для дошкольников по испанскому языку поможет детям:</p>

            <ul>
              <li><span>Развить внимание и творческую фантазию, улучшить память. Этому способствует частая смена интересных заданий в ходе видеоурока.</span></li>
              <li><span>Сформировать или расширить словарный запас благодаря общению с опытным преподавателем и применению специальных методик.</span></li>
              <li><span>Научиться понимать живую испанскую речь, без стеснения задавать вопросы и отвечать на них по-испански.</span></li>
            </ul>

            <p>После окончания курса ребёнок получит яркий красочный сертификат, который долгие годы будет служить для него источником приятных воспоминаний.</p>

            <p>Учить иностранные языки онлайн &mdash; это модно, удобно и доступно абсолютно всем! Специалисты Полиглотиков разработали более 70 программ на английском, испанском, немецком, французском и китайском языках для школьников и детей дошкольного возраста. Начните заниматься прямо сейчас, и вы обязательно получите хороший результат!</p>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Lang2Age2"
}
</script>

<style scoped>
.no-shadow p,li{color: #000; font-size: 18px;}
.no-shadow ul li{margin-bottom: 20px; padding-left: 10px;}
.no-shadow ul {list-style-image: url(~@/assets/hometeacher/images/redok.png);}
.no-shadow{margin-bottom: 70px;}
.no-shadow li{font-family: "Manrope Bold"; color:#5ab947;}
.no-shadow li span {font-family: "Manrope Light"; color: #000;}
.no-shadow ol li{margin-bottom: 20px; padding-left: 5px;}
</style>
